import component from './bottom.component';
import statusPage from './status/status.module';

export default angular.module('mpdx.bottom', [component, statusPage]).name;
